import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Text, View, XStack, YStack } from "tamagui";
import { type Emoji, EmojiPicker } from "../../../ui/EmojiPicker";
import { Input } from "../../../ui/InputNew";
import { Label } from "../../../ui/Label";

const BusinessEmojiPickerForm: React.FC<{
  value?: string;
  onChange: (emoji: Emoji) => void;
}> = (props) => {
  const [emojiSheetOpen, setEmojiSheetOpen] = useState(false);
  const [emoji, setEmoji] = useState(props.value);
  const icon = emoji ?? "?";

  return (
    <XStack gap="$small" alignItems="center" cursor="pointer">
      <View
        onPress={() => setEmojiSheetOpen(true)}
        cursor="pointer"
        borderWidth={1}
        borderColor={"$divider"}
        backgroundColor={"$background"}
        alignItems="center"
        justifyContent="center"
        width={50}
        height={50}
      >
        <Text lineHeight={24} fontSize={24}>
          {icon}
        </Text>
      </View>
      <EmojiPicker
        sheetId="emoji"
        open={emojiSheetOpen}
        onOpenChange={(open: boolean) => setEmojiSheetOpen(open)}
        onSelect={(emoji) => {
          setEmojiSheetOpen(false);
          setEmoji(emoji.emoji);
          props.onChange(emoji);
        }}
      />
    </XStack>
  );
};

type FormData = {
  emoji?: string | null;
  title?: string | null;
};

export const BusinessAdminTitleAndEmojiEdit = observer(
  ({
    formValues,
    onChange,
  }: {
    formValues: FormData;
    onChange: (formValues: FormData) => void;
  }) => {
    return (
      <YStack gap="$small">
        <Label>Title</Label>
        <XStack>
          <BusinessEmojiPickerForm
            value={formValues.emoji ?? undefined}
            onChange={(newEmoji) => {
              formValues.emoji = newEmoji.emoji;
              return onChange(formValues);
            }}
          />
          <Input
            marginLeft={-1}
            flex={1}
            type="border"
            defaultValue={formValues.title ?? undefined}
            submitOnBlur
            onSubmitEditing={(e) => {
              formValues.title = e.nativeEvent.text;
              return onChange(formValues);
            }}
          />
        </XStack>
      </YStack>
    );
  },
);
